import {createStore, applyMiddleware, combineReducers} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension'
import {auto, mergeReducers} from 'redux-auto'
import rootReducer from './index'
import ErrorReporter from './middleware/ErrorReporter'

const middlewares = []

const autoReducers = require.context('./auto', true, /^(?!.*\.spec\.js$).*\.js$/)
middlewares.push(ErrorReporter)
middlewares.push(auto(autoReducers, autoReducers.keys()))

const appliedMiddlewares = composeWithDevTools(applyMiddleware(...middlewares))

const combinedReducers = combineReducers(mergeReducers(rootReducer))

export const store = createStore(combinedReducers, appliedMiddlewares)
